import { createActionGroup, props } from '@ngrx/store';

export const HostedPaymentsPadResultComponentActions = createActionGroup({
  source: 'Pad Result Component',
  events: {
    Initialized: props<{ payload: string }>(),
  },
});
